<header class="custom-header">
  <div class="header-left">
    <a class="pushmenu-btn" data-widget="pushmenu" href="#" role="button" title="Toggle Menu">
      <i class="fas fa-bars"></i>
    </a>
    <span class="user-name">{{ name | uppercase }}</span>
  </div>

  <div class="header-right">
    <button mat-icon-button (click)="logout()" matTooltip="Logout" class="logout-btn">
      <mat-icon>logout</mat-icon>
    </button>
  </div>
</header>